'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'umbrella-beach';
var width = 512;
var height = 512;
var aliases = [127958];
var unicode = 'f5ca';
var svgPathData = 'M464 256c0-114.9-93.1-208-208-208-64 0-121.4 28.9-159.6 74.6L458.5 303.6c3.6-15.3 5.5-31.2 5.5-47.6zM228.1 242.1c-124.7-62.4-191.7-95.9-201.2-100.6 7.2-14.5 15.8-28.1 25.6-40.9 46.8-61.2 120.5-100.6 203.5-100.6 141.4 0 256 114.6 256 256 0 24.1-3.3 47.4-9.6 69.6-4.4 15.5-10.2 30.4-17.2 44.6l-.2 .4-214-107-1.6 3.2-98.6 197.3 341.2 0 0 48-512 0 0-48 117.2 0 109.4-218.7 1.6-3.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUmbrellaBeach = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;